"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Checkbox = _interopRequireDefault(require("@micado-digital/react-form/Checkbox"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _DataPrivacy = _interopRequireDefault(require("./DataPrivacy.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DataPrivacy = _ref => {
  var _systemLink, _systemLink2;
  let {
    accepted,
    error,
    lang,
    setAccepted
  } = _ref;
  const systemLink = (0, _useSystemLinks.default)();
  const css = (0, _DataPrivacy.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const agbUrl = (_systemLink = systemLink("agb")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  const dataPrivacyUrl = (_systemLink2 = systemLink("privacy")) !== null && _systemLink2 !== void 0 ? _systemLink2 : "/";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.dataPrivacy, "mco-shop-checkout-data-privacy")
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: accepted,
    error: error,
    label: l("reactShop.checkout.text.dataPrivacy", {
      agbUrl,
      dataPrivacyUrl
    }),
    name: "accepted",
    setChecked: setAccepted,
    value: true
  }));
};
var _default = exports.default = DataPrivacy;